import axios from "axios";
import React, { useEffect, useState } from "react";

import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { faEraser, faList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import Footer from "../common/components/Footer";
import Header from "../common/components/ui/Header";
import consts from "../consts";
import { cnpjMask } from "../functions/mask";

function Contas() {
  const [lista, setLista] = useState([]);
  const [filter, setFilter] = useState("");
  const [viewMode, setViewMode] = useState(localStorage.planoViewMode);

  useEffect(() => {
    axios.get(`${consts.API_URL}/bancarios`).then((resp) => {
      setLista(resp.data);
    });
  }, []);

  return (
    <div className="min-h-screen dark:bg-[#121212] dark:text-white">
      <Header text="Plano de Contas" />
      <div className="container h-full pt-2 pb-10 px-4 mx-auto">
        <div className="flex flex-col justify-between gap-4 mt-5 md:flex-row">
          <div className="flex flex-col gap-1 w-full md:w-2/3">
            <span className="text-sm">Filtrar por nome</span>
            <div className="flex gap-2">
              <input
                type="text"
                className="p-3 border border-gray-300 rounded-md outline-none dark:text-black w-full max-w-md"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                placeholder="Digite o nome da empresa"
              />
              {filter.length >= 1 ? (
                <Tooltip title="Limpar">
                  <button
                    className="px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-300 dark:text-black"
                    onClick={() => setFilter("")}
                  >
                    <FontAwesomeIcon icon={faEraser} size={"md"} />
                  </button>
                </Tooltip>
              ) : null}
            </div>
          </div>
          <div className="flex items-end md:items-center justify-start md:justify-end">
            {viewMode ? (
              <Tooltip title="Modo Card">
                <span
                  onClick={() => {
                    setViewMode(false);
                    localStorage.planoViewMode = false;
                  }}
                  className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-xl cursor-pointer"
                >
                  <FontAwesomeIcon icon={faSquare} size="md" />
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="Modo Lista">
                <span
                  onClick={() => {
                    setViewMode(true);
                    localStorage.planoViewMode = true;
                  }}
                  className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-xl cursor-pointer"
                >
                  <FontAwesomeIcon icon={faList} size="md" />
                </span>
              </Tooltip>
            )}
          </div>
        </div>
        {viewMode ? (
          <>
            <div className="hidden lg:grid grid-cols-8 gap-4 p-4 mt-5 text-lg font-bold bg-blue-100 dark:bg-slate-700">
              <span className="col-span-2">Empresa</span>
              <span>Conta</span>
              <span>Agência</span>
              <span>CNPJ</span>
              <span className="col-span-2">FID - Banco</span>
              <span>Ação</span>
            </div>
            <div className="flex flex-col gap-2 mt-2">
              {lista
                .filter((val) => {
                  if (filter === "") {
                    return val;
                  } else if (
                    val.razaosocial
                      .toLowerCase()
                      .includes(filter.toLocaleLowerCase())
                  ) {
                    return val;
                  } else {
                    return null;
                  }
                })
                .map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-8 gap-4 p-4 bg-gray-50 dark:bg-slate-800 text-sm"
                    >
                      <span className="font-semibold col-span-2">
                        {item.razaosocial}
                      </span>
                      <span>{item.conta}</span>
                      <span>{item.agencia}</span>
                      <span>{cnpjMask(item.cnpj)}</span>
                      <span className="col-span-2">
                        {item.fid} - {item.banco}
                      </span>
                      <span className="flex justify-center gap-2 px-2 py-1 bg-blue-100 rounded-md text-sm dark:bg-blue-700 dark:text-white hover:bg-blue-200 dark:hover:bg-blue-600 cursor-pointer">
                        <Link
                          className="font-semibold"
                          to={`/${item.cnpj}/contasDetalhe`}
                        >
                          Plano de Contas
                        </Link>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="self-center w-4 h-4"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                          />
                        </svg>
                      </span>
                    </div>
                  );
                })}
            </div>
          </>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mt-10">
            {lista
              .filter((val) => {
                if (filter === "") {
                  return val;
                } else if (
                  val.razaosocial
                    .toLowerCase()
                    .includes(filter.toLocaleLowerCase())
                ) {
                  return val;
                } else {
                  return null;
                }
              })
              .map((item, index) => {
                return (
                  <>
                    <div
                      key={index}
                      className="flex flex-col justify-between p-4 shadow-md rounded-xl bg-gray-50 dark:text-white dark:bg-gray-700"
                    >
                      <div className="flex flex-col justify-between w-full gap-4 mb-2 align-items-center">
                        <span className="text-xl font-bold text-center mb-4">
                          {item.razaosocial}
                        </span>
                      </div>
                      <div className="flex flex-col gap-2 text-sm">
                        <span className="p-2 bg-white rounded-md dark:bg-gray-600">
                          Conta: {item.conta}
                        </span>
                        <span className="p-2 bg-white rounded-md dark:bg-gray-600">
                          Agencia {item.agencia}
                        </span>
                        <span className="p-2 bg-white rounded-md dark:bg-gray-600">
                          Cnpj: {item.cnpj}
                        </span>
                        <span className="p-2 bg-white rounded-md dark:bg-gray-600">
                          {item.fid} - {item.banco}
                        </span>
                        <span className="flex justify-center items-center gap-2 px-2 py-1 bg-blue-100 rounded-md dark:bg-blue-700 dark:text-white hover:bg-blue-200 dark:hover:bg-blue-600 cursor-pointer">
                          <Link
                            className="font-semibold"
                            to={`/${item.cnpj}/contasDetalhe`}
                          >
                            Plano de Contas
                          </Link>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="self-center w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default Contas;
